import Vue from 'vue';
import PortalVue from 'portal-vue';

export default function () {
    Vue.use(PortalVue);
}